/** Planos (ADR-009, ADR-021). Sem dependências: usado também pelo interceptor do axios. */
export type PlanName = "Free" | "Pro" | "Couple" | "Family"

export const PLAN_LABEL: Record<PlanName, string> = {
  Free: "Free",
  Pro: "Pro",
  Couple: "Casal",
  Family: "Família",
}

interface PlanHolder {
  planType?: PlanName
  effectivePlan?: PlanName
}

/** Plano que vale para a pessoa: o efetivo (próprio ou do grupo); a API antiga só manda o próprio. */
export function effectivePlanOf(user: PlanHolder | null | undefined): PlanName {
  return user?.effectivePlan ?? user?.planType ?? "Free"
}

/** Tem os recursos Pro: assina Pro, Casal ou Família, ou é membro de um grupo. */
export function hasProPlan(user: PlanHolder | null | undefined): boolean {
  return effectivePlanOf(user) !== "Free"
}

/** Plano de grupo: o titular tem carteira conjunta e convida pessoas (ADR-021). */
export function isGroupPlan(plan: PlanName | undefined): boolean {
  return plan === "Couple" || plan === "Family"
}
